var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomTax = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.834 8.904h3.556l-3.556-3.565v3.565zM25.113 14.05H5.486a.604.604 0 0 0-.61.61v6.698c0 .343.268.611.61.611h19.627c.343 0 .61-.268.61-.611V14.66a.614.614 0 0 0-.61-.612zM11.706 16.33h-1.012v3.953a.604.604 0 0 1-.61.611.604.604 0 0 1-.61-.611V16.33H8.462a.604.604 0 0 1-.61-.611c0-.343.268-.612.61-.612h3.259c.342 0 .61.269.61.612a.617.617 0 0 1-.625.611zm5.595 4.534a.617.617 0 0 1-.789-.358l-.223-.581H14.28l-.223.581a.625.625 0 0 1-.565.403.613.613 0 0 1-.566-.835c1.786-4.713 1.697-4.504 1.712-4.52a.716.716 0 0 1 .67-.447c.312 0 .565.194.669.463l1.681 4.504a.619.619 0 0 1-.357.79zm4.836.045a.6.6 0 0 1-.49-.253l-1.132-1.581-1.13 1.58a.62.62 0 0 1-.492.254.61.61 0 0 1-.49-.97l1.368-1.923-1.369-1.924a.606.606 0 0 1 .15-.85.602.602 0 0 1 .847.149l1.131 1.58 1.131-1.58a.616.616 0 0 1 .848-.15.619.619 0 0 1 .15.85l-1.37 1.925 1.37 1.924c.267.402-.03.97-.522.97z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.837 24.624c0 .671.55 1.223 1.22 1.223h12.455c.67 0 1.22-.552 1.22-1.223v-1.432H7.838v1.432zM22.747 10.127h-4.523a.604.604 0 0 1-.61-.612V4.951H9.057c-.67 0-1.22.597-1.22 1.268v6.607h14.91v-2.7zm-8.75 1.312h-2.946a.604.604 0 0 1-.61-.611c0-.343.268-.612.61-.612h2.932c.342 0 .61.269.61.612a.601.601 0 0 1-.595.611zm0-2.625h-2.946a.604.604 0 0 1-.61-.611c0-.343.268-.612.61-.612h2.932c.342 0 .61.269.61.612a.601.601 0 0 1-.595.611z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M14.757 18.703h1.086l-.536-1.432z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomTax);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-tax.da780c731ba91c764babc142264c03f1.svg";